module.exports = __webpack_public_path__ + "static/dashboard@2x-3ea48aac859025a3acd147dc5979804f.png";